<template>
  <div id="app" :class="{ 'has-header': showHeader, 'no-header': !showHeader }">
    <Header v-if="showHeader"></Header>
    <LeftMenu ref="LeftMenu"></LeftMenu>
    <router-view :key="$route.fullPath" />
  </div>
</template>

<script>
import "./assets/style/admin.css";
import "./assets/style/custom.css";
import "./assets/style/pageing.css";

import Header from "@/components/common/Header.vue";
import LeftMenu from "@/components/common/LeftMenu.vue";
import { mapActions } from "vuex";

export default {
  name: "app",
  components: {
    Header,
    LeftMenu,
  },
  data() {
    return {
      showHeader: true
    };
  },
  methods: {
    ...mapActions("common", ["setMallId"]),
    
    // 헤더 표시 여부 초기화
    initializeHeaderVisibility() {
      // sessionStorage에서 헤더 설정 확인
      const headerSetting = sessionStorage.getItem("supply_header_visible");
      
      // URL 파라미터에서 header 확인
      const urlParams = new URLSearchParams(window.location.search);
      const headerParam = urlParams.get("header");
      
      if (headerParam === "no") {
        // URL에서 header=no가 있으면 헤더 숨김
        this.showHeader = false;
        sessionStorage.setItem("supply_header_visible", "false");
      } else if (headerSetting === "false") {
        // sessionStorage에 숨김 설정이 있으면 계속 숨김
        this.showHeader = false;
      } else {
        // 기본값: 헤더 표시
        this.showHeader = true;
        sessionStorage.setItem("supply_header_visible", "true");
      }
    },
    
    // 앱 초기화 시 mall_id 설정
    initializeMallId() {
      // sessionStorage에서 mall_id 가져오기
      let mallId = sessionStorage.getItem("supply_mall_id");
      
      // sessionStorage에 없으면 URL 파라미터에서 가져오기
      if (!mallId) {
        const urlParams = new URLSearchParams(window.location.search);
        mallId = urlParams.get("mall_id");
        
        // URL 파라미터에서 가져온 경우 sessionStorage에 저장
        if (mallId) {
          sessionStorage.setItem("supply_mall_id", mallId);
        }
      }
      
      // store에 mall_id 설정
      if (mallId) {
        this.setMallId(mallId);
      }
    }
  },
  
  created() {
    this.initializeHeaderVisibility();
    this.initializeMallId();
  }
};
</script>

<style>
/* 헤더가 있을 때 메인 콘텐츠 영역 */
.has-header .router-view,
.has-header main,
.has-header .main-content,
.has-header .content-area {
  margin-top: 56px; /* 헤더 높이만큼 상단 여백 */
}

/* 헤더가 없을 때 메인 콘텐츠 영역 */
.no-header .router-view,
.no-header main,
.no-header .main-content,
.no-header .content-area {
  margin-top: 0; /* 상단 여백 제거 */
}

/* 좌측 메뉴 조정 */
.has-header .left-menu {
  top: 56px; /* 헤더 높이만큼 아래로 */
}

.no-header .left-menu {
  top: 0; /* 상단에 붙임 */
}

/* 앱 전체 패딩 조정 */
.no-header {
  padding-top: 0 !important;
}

.has-header {
  padding-top: 56px; /* 헤더 높이만큼 */
}

/* 추가적인 레이아웃 조정 */
.no-header body,
.no-header html {
  margin-top: 0 !important;
  padding-top: 0 !important;
}
</style>
